export enum WaitingListFilterKeys {
  selectedWarehouseId = 'selectedWarehouseId',
  preferredDateFrom = 'preferredDateFrom',
  preferredDateTo = 'preferredDateTo',
  unitType = 'unitType',
  squareFrom = 'squareFrom',
  squareTo = 'squareTo',
}
